
//суммарная комиссия брокера и биржи за полную сделку, т.е. открытие и закрытие, %
export const commissionOfBroker = 0.2

//условная годовая среднерыночная доходность, взята по облигациям, %
export const conditionalAverageMarketIncome = 8
//какую доходность жду в сделке минимально для закрытия если пошло не по плану стратегии, в среднерыночных условных доходностях
export const minIncomeInOrderForClose = 2